export default "__VITE_ASSET__DNeT1JNO__"